 
import DataLoading from "@components/loader.data";
import { useNavigate } from "react-router";
import { constants } from "@lib/constants";

const normalizeImageSource = (value) => {
  if (!value) return null;

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  return `${constants.S3_URL}${value}`;
};

const ProfileCard =({profileData,close})=>{
    const navigate=useNavigate()
    
    // Profile picture is at root level for both artist and agency
    const profilePicValue = profileData?.profilePic;
    
    const picture = normalizeImageSource(profilePicValue);

    return <div onClick={()=>{navigate("/profile"),close()}} className="py-5 lg:w-100 shrink-0 p-2 d-flex  gap-3 mont lg:border lg:rounded-2xl lg:shadowmobile">
      {!profileData?

                <DataLoading/>:
                <>
                {/* Profile Picture */}
                {picture ? (
                  <>
                    <img
                      src={picture}
                      alt=""
                      className="h-100 w-100 rounded-2xl d-none d-lg-block object-cover object-center"
                      style={{ aspectRatio: "1 / 1" }}
                    />

                    <img
                      src={picture}
                      alt=""
                      className="h-20 w-20 rounded-full d-lg-none d-block shrink-0 object-cover object-center"
                    />
                  </>
                ) : (
                  <>
                    <div
                      className="h-100 w-100 rounded-2xl d-none d-lg-block bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center"
                      style={{ aspectRatio: "1 / 1" }}
                    >
                      <span className="text-2xl font-bold text-white">
                        {(profileData?.firstName?.charAt(0) || "U").toUpperCase()}
                      </span>
                    </div>

                    <div
                      className="h-20 w-20 rounded-full d-lg-none d-block shrink-0 bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center"
                    >
                      <span className="text-lg font-bold text-white">
                        {(profileData?.firstName?.charAt(0) || "U").toUpperCase()}
                      </span>
                    </div>
                  </>
                )}

                
                {/* Profile Data */}
                  <div className="d-flex flex-col text-gray-600 justify-center gap-1 h-20 poppins">
                    <p className="font-medium text-base">
                      {profileData?.firstName} 
                      <br></br>
                      {profileData?.lastName}
                    </p>
                    <p className="text-sm text-gray-500 dark:!text-gray-300 font-normal">
                      {profileData?.profiles?.map((val, i) => {
                        return (
                          <span key={i}>
                            <span>{val?.artistCategory?.title}</span>
                            {profileData?.profiles?.length > 0 && (
                              <span className={``}>
                                {i + 1 !== profileData?.profiles?.length ? ` • ` : null}</span>
                            )}
                          </span>
                        );
                      })} 
                    </p>
                    
                  </div>
                  
               
                {/* Social Media */}
                {/* {profileData?.socialMedia && <CustomSocials profileData={profileData} />} */}
               
    
                </>  }     
              </div>
}
export default ProfileCard